import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaPalette,
  FaCogs,
  FaRocket,
} from "react-icons/fa";

export default function Soft() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <FaLaptopCode />,
      title: "E-Commerce",
      desc: "High-conversion stores with fast checkout & payments",
      img: "https://images.unsplash.com/photo-1557821552-17105176677c",
    },
    {
      icon: <FaMobileAlt />,
      title: "Web Apps",
      desc: "Scalable dashboards & real-time systems",
      img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
    },
    {
      icon: <FaPalette />,
      title: "Admin Panels",
      desc: "Analytics, workflows & automation tools",
      img: "https://images.unsplash.com/photo-1620885174261-16e2b0f6c0c9",
    },
    {
      icon: <FaCogs />,
      title: "Portfolios",
      desc: "Clean, minimal & brand-driven websites",
      img: "https://images.unsplash.com/photo-1531497865144-0464ef8fb9a9",
    },
    {
      icon: <FaRocket />,
      title: "Corporate",
      desc: "Enterprise-ready performance websites",
      img: "https://images.unsplash.com/photo-1542744173-05336fcc7ad4",
    },
  ];

  return (
    <div className="bg-[#0b0f1a] text-white min-h-screen">
      <Header />

      {/* 🔥 HERO (BENTO STYLE) */}
      <section className="max-w-7xl mx-auto px-6 pt-24 pb-16 grid lg:grid-cols-2 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight">
            Build{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-500">
              Future-Ready
            </span>{" "}
            Products
          </h1>

          <p className="mt-6 text-gray-400 text-lg">
            We design & develop powerful digital systems that scale your
            business globally.
          </p>

          <div className="flex gap-4 mt-8">
            <button
              onClick={() => navigate("/contact")}
              className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full font-bold hover:scale-105 transition"
            >
              🚀 Start Project
            </button>

            <button className="px-8 py-4 border border-white/20 rounded-full hover:bg-white/10 transition">
              View Work
            </button>
          </div>
        </motion.div>

        {/* BENTO CARDS */}
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2 bg-gradient-to-br from-purple-600/20 to-pink-500/20 p-6 rounded-2xl backdrop-blur-xl border border-white/10">
            <h3 className="text-xl font-bold">10x Faster Development</h3>
            <p className="text-gray-400 text-sm mt-2">
              Optimized workflows & AI-powered systems
            </p>
          </div>

          <div className="bg-white/5 p-6 rounded-2xl backdrop-blur-xl border border-white/10">
            ⚡ Performance
          </div>

          <div className="bg-white/5 p-6 rounded-2xl backdrop-blur-xl border border-white/10">
            🔐 Secure
          </div>
        </div>
      </section>

      {/* 💎 SERVICES GRIDS */}
      <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((s, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -10 }}
            className="group relative rounded-2xl overflow-hidden bg-white/5 border border-white/10 backdrop-blur-xl"
          >
            <img
              src={`${s.img}?auto=format&fit=crop&w=900&q=80`}
              alt={s.title}
              className="h-52 w-full object-cover group-hover:scale-110 transition"
            />

            <div className="p-6">
              <div className="text-purple-400 text-2xl mb-3">{s.icon}</div>

              <h3 className="text-lg font-bold">{s.title}</h3>
              <p className="text-gray-400 text-sm mt-2">{s.desc}</p>

              <button
                onClick={() => navigate("/quotes")}
                className="mt-5 text-sm text-purple-400 hover:underline"
              >
                Get Quote →
              </button>
            </div>

            {/* glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/0 to-pink-500/0 group-hover:from-purple-500/10 group-hover:to-pink-500/10 transition"></div>
          </motion.div>
        ))}
      </section>

      {/* 🚀 CTA */}
      <section className="text-center py-24 px-6">
        <h2 className="text-4xl font-bold">Let’s Build Something Big 🚀</h2>

        <p className="text-gray-400 mt-4">
          Ready to scale your business with next-gen technology?
        </p>

        <button
          onClick={() => navigate("/contact")}
          className="mt-8 px-10 py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full font-bold hover:scale-105 transition"
        >
          Start Now
        </button>
      </section>

      <Footer />
    </div>
  );
}
